<template>
  <v-row align="stretch">
    <v-col cols="12" sm="6">
      <v-card flat color="grey lighten-3">
        <v-card-title
          ><span class="caption" style="opacity: 0.7;"
            >Préparations automatiques</span
          ></v-card-title
        >
        <v-card-text class="px-2">
          <v-row align="center" justify="start" no-gutters>
            <v-chip
              v-for="item in automaticPreparations"
              :key="item.id"
              label
              large
              close
              class="ma-1"
              @click:close="$emit('remove', item)"
            >
              {{
                `${item.quantity} ${getProductUnit(item)} de ${getProductName(
                  item
                )}`
              }}
            </v-chip>
            <span class="overline ml-2" v-if="automaticPreparations.length < 1"
              >Aucune préparation automatique</span
            >
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6">
      <v-card flat color="grey lighten-3">
        <v-card-title
          ><span class="caption" style="opacity: 0.7;"
            >Préparations planifiées</span
          ></v-card-title
        >
        <v-card-text class="px-2">
          <v-row align="center" justify="start" no-gutters>
            <v-chip
              v-for="item in scheduledPreprations"
              :key="item.id"
              label
              large
              class="ma-1"
            >
              <v-row align="center" justify="space-between" no-gutters>
                <span>
                  {{
                    `${Number(item.quantity)} ${getProductUnit(
                      item
                    )} de ${getProductName(item)}`
                  }}</span
                >
                <ScheduledPrepEditor
                  icon
                  :id="item.id"
                  @update="$emit('update')"
                ></ScheduledPrepEditor>
              </v-row>
            </v-chip>
            <span class="overline ml-2" v-if="scheduledPreprations.length < 1"
              >Aucune préparation planifiée</span
            >
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ScheduledPrepEditor from "./ScheduledPrepEditor";
import { mapGetters } from "vuex";
export default {
  name: "PreparationSlipEditorAutomaticPrep",
  components: {
    ScheduledPrepEditor
  },
  props: {
    automaticPreparations: {
      type: Array,
      required: true
    },
    scheduledPreprations: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getProducts"])
  },
  methods: {
    getProductName(item) {
      const p = this.getProducts.find(x => x.id === item.fk_product);
      return p ? p.nom : "";
    },
    getProductUnit(item) {
      const p = this.getProducts.find(x => x.id === item.fk_product);
      return p && p.data ? p.data.unite_mesure_inventory : "";
    }
  }
};
</script>

<style></style>
